<div class="header-flag">
  <img *ngIf="country?.code" class="header-flag__image" [src]="'assets/images/flags/' + (country?.code | lowercase) + '.svg'" [alt]="country?.name + ' flag'" />
</div>
